import React from "react";
import { Space } from "antd";
import ZohoLogo from "../../../images/logos/zoho_crm.png";
import logoStripe from "./images/stripe.png";
import ParseLogo from "./images/parse.png";
import JiraLogo from "./images/jira.png";
import config from "../../../api_config.json";
import { useAppContext } from "../../../context";

const sizes = {
  small: 20,
  large: 30,
};

const OrgLinks = (props) => {
  const { isProd } = useAppContext();
  const { org, size = "small", style } = props;

  if (org.nome) {
    const zohoCrmUrl = `https://crm.zoho.eu/crm/org20108764695/search?searchword=${encodeURIComponent(org.objectId)}&isRelevance=false`;

    return (
      <Space direction="horizontal" style={style}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={zohoCrmUrl}
        >
          <img src={ZohoLogo} width={sizes[size]} alt="Cerca in Zoho CRM" />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`${
            config.parseDashboard[isProd ? "prod" : "dev"]
          }/browser/organizzazione?filters=[{"field":"objectId","constraint":"eq","compareTo":"${
            org.objectId
          }"}]`}
        >
          <img src={ParseLogo} width={sizes[size]} alt="logo" />
        </a>        
        {org.jira_id && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`https://onoranzefunebricloud.atlassian.net/jira/servicedesk/projects/SC/organizations/${org.jira_id}`}
          >
            <img src={JiraLogo} width={sizes[size]} alt="logo" />
          </a>
        )}
        {org.stripe_customer_id && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`https://dashboard.stripe.com/customers/${org.stripe_customer_id}`}
          >
            <img src={logoStripe} width={sizes[size]} alt="logo" />
          </a>
        )}
      </Space>
    );
  }

  if (org.email) {
    return (
      <Space direction="horizontal" style={style}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://crm.zoho.eu/crm/org20108764695/search?searchword=${encodeURIComponent(org.objectId)}&isRelevance=false`}
        >
          <img src={ZohoLogo} width={sizes[size]} alt="Cerca in Zoho CRM" />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`${
            config.parseDashboard[isProd ? "prod" : "dev"]
          }/browser/organizzazione?filters=[{"field":"objectId","constraint":"eq","compareTo":"${
            org.objectId
          }"}]`}
        >
          <img src={ParseLogo} width={sizes[size]} alt="logo" />
        </a>
      </Space>
    );
  }

  return <></>;
};

export default OrgLinks;
